import { Building2 } from "lucide-react";

export default function ProductionStudios() {
  return (
    <div className="dm-page-container" style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", minHeight: "60vh", gap: 16,
      textAlign: "center", padding: "40px 20px"
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: 16,
        background: "rgba(168,85,247,0.1)",
        border: "1px solid rgba(168,85,247,0.2)",
        display: "flex", alignItems: "center", justifyContent: "center"
      }}>
        <Building2 size={28} style={{ color: "#A855F7" }} />
      </div>
      <h1 style={{
        fontFamily: "var(--font-orb)", fontSize: 20,
        color: "var(--t1)", letterSpacing: ".08em"
      }}>STUDIOS & VENUES</h1>
      <p style={{
        fontFamily: "var(--font-mono)", fontSize: 13,
        color: "var(--t3)", letterSpacing: ".06em", maxWidth: 400
      }}>Coming Soon</p>
      <p style={{
        fontFamily: "var(--font-sans)", fontSize: 13,
        color: "var(--t4)", maxWidth: 400, lineHeight: 1.5
      }}>
        Studio booking, venue management, and production scheduling
        are being built. Stay tuned.
      </p>
    </div>
  );
}
